import axios from 'axios';

export default axios.create({
  // Url of the Server, you will find URL configered in .env.[mode] file.
  baseURL: process.env.VUE_APP_SERVICE_URL,

  // To set the content type for the request/response
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest',
  },

  // This is to send the session alongside the request
  withCredentials: true,

  // This is to send an empty body with post request (chrome doesn't like empty CORS post request)
  transformRequest: [(data) => {
    return {...data};
  }, ...axios.defaults.transformRequest],
});

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
   return Promise.reject(error);
});